import { Box, Container, Text, Button, Flex } from "@mantine/core";
import { useSelector, useDispatch } from "react-redux";
import { ClientContext } from "../components/ClientProvider";
import { Api } from "telegram";
import {setWorkflowStep, removeFolder, apiLogout} from "../store/reducers/root";
import { useState, useContext, useEffect } from "react";
import FolderSelector from "../components/dashboard/FolderSelector";
import Landing from "../components/dashboard/Landing";
import MessageComposer from "../components/dashboard/MessageComposer";
import sendMessageAsDraft from "../utils/actions/sendMessageAsDraft";
import sendMessageNow from "../utils/actions/sendMessageNow";

import { refreshChannels } from "../utils/actions/refreshChannels";

import sendMultiMedia from "../utils/actions/sendMultiMedia";
import Header from "../components/dashboard/header";
import Logo3RM from "../components/dashboard/Logo";
import AlertToast from "../components/dashboard/AlertToast";
import { useFiles } from "../hooks/useFiles";
import sendFile from "../utils/actions/sendFile";
import { AppContext } from "../contexts/appContext";
import { useSerializeMessage } from "../hooks/useSerializeMessage";

export default function Dashboard() {
  const client = useContext(ClientContext);
  const { filesContext } = useContext(AppContext);

  const user = useSelector((state) => state.user);
  const channels = useSelector((state) => state.channels);
  const folder = useSelector((state) => state.folder);
  const message = useSelector((state) => state.message);
  const [images, setImages] = useState([]);
  const workflowStep = useSelector((state) => state.workflowStep);

  const [loading, setLoading] = useState(false);

  const [refresh, setRefresh] = useState(false);
  // const [messageSerialized, setMessageSerialized] = useState("");
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [newFiles, setNewFiles] = useState(false);
  const [customErrorMessage, setCustomErrorMessage] = useState(undefined);

  const dispatch = useDispatch();
  const filesArray = useFiles();
  const messageSerialized = useSerializeMessage(message);

  const handleFileUpload = () => {
    setNewFiles(!newFiles);
  };

  const handleMainButtonClick = () => {
    switch (workflowStep) {
      case 0:
        if (folder) {
          dispatch(setWorkflowStep(2));
        }
        break;
      case 1:
        if (messageSerialized.length !== 0 && folder) {
          dispatch(setWorkflowStep(2));
        }
        break;
      default:
        break;
    }
  };

  const handleSendAsDraft = async () => {
    if(!client) return;
    const isLoggedIn = await client.isUserAuthorized();
    if(!isLoggedIn) {
      dispatch(apiLogout());
      window.location.reload();
    }
    await sendMessageAsDraft(
      client,
      dispatch,
      folder,
      setShowSuccessAlert,
      setShowErrorAlert,
      setLoading,
      messageSerialized,
    );
  };

  const handleSendNow = async () => {
    if(!client) return;
    const isLoggedIn = await client.isUserAuthorized();
    if(!isLoggedIn) {
      dispatch(apiLogout());
      window.location.reload();
    }

    let result;
    setLoading(true);

    if (images.length > 0 && filesArray.length === 0) {
      result = await sendMultiMedia(
        client,
        dispatch,
        folder,
        messageSerialized,
        images,
      );
    } else if (filesArray.length !== 0) {
      if (images.length > 0) {
        result = await sendMultiMedia(
          client,
          dispatch,
          folder,
          messageSerialized,
          images,
        );
      }
      result = await sendFile({
        client,
        dispatch,
        folder,
        message: images.length > 0 ? "" : messageSerialized,
        files: filesArray,
      });
    } else {
      result = await sendMessageNow(
        client,
        folder,
        dispatch,
        setShowSuccessAlert,
        setShowErrorAlert,
        setLoading,
        messageSerialized,
      );
    }
    if (result) {
      if (result) window.open(result, "_blank");
      setShowSuccessAlert(true);
      setImages([]);
      filesContext.clearFiles();
      handleFileUpload();
    } else {
      setShowErrorAlert(true);
    }
    setLoading(false);
  };

  async function handleRefreshChannels() {
    if (!client) return;
    await refreshChannels(client, dispatch);
  }

  useEffect(() => {
    if (!client) return;
    client.addEventHandler(async (event) => {
      if (event instanceof Api.UpdateDialogFilter) {
        await handleRefreshChannels();
      }
    });
  }, [client]);

  useEffect(() => {
    (async () => {
      if (user.logged && client && !channels.length) {
        setLoading(true);
        await handleRefreshChannels();
        setLoading(false);
      }
    })();
  }, [user.logged]);

  useEffect(() => {
    (async () => {
      if (user.logged && client) {
        setLoading(true);
        await handleRefreshChannels();
        setLoading(false);
      }
    })();
  }, [refresh]);

  useEffect(() => {
    switch (workflowStep) {
      case 0:
        if (folder?.value) {
          setIsDisabled(false);
        } else {
          setIsDisabled(true);
        }
        break;
      case 2:
        if (messageSerialized.length > 1) {
          setIsDisabled(false);
        } else {
          setIsDisabled(true);
        }
        break;
      default:
        break;
    }
  }, [folder, workflowStep, message, messageSerialized]);

  useEffect(() => {
    if (workflowStep === 0) {
      dispatch(removeFolder());
    }
  }, [workflowStep]);

  return (
    <>
      {!user.logged ? (
        <Landing />
      ) : (
        <Container fluid maw={"100%"} h={"70vh"}>
          <Header loading={loading} setLoading={setLoading} />
          <Flex
            direction={"column"}
            align={"center"}
            justify={"center"}
            content={"center"}
            w={"100%"}
            h={"100%"}
          >
            <Logo3RM />
            <Box maw={"95%"} align="center" mx={"auto"}>
              <Container fluid maw={"450px"} h={"300px"}>
                {workflowStep === 0 && (
                  <FolderSelector
                    refresh={refresh}
                    setRefresh={setRefresh}
                    loading={loading}
                  />
                )}
                {(workflowStep === 1 || workflowStep === 2) && (
                  <MessageComposer
                    workflowStep={workflowStep}
                    images={images}
                    setImages={setImages}
                    handleFileUpload={handleFileUpload}
                  />
                )}

                {workflowStep !== 2 && (
                  <Button
                    w={"100%"}
                    color={"dark"}
                    mb={"lg"}
                    disabled={isDisabled}
                    onClick={handleMainButtonClick}
                  >
                    {workflowStep === 0
                      ? "Continue"
                      : `Preview before send to ${folder.label}`}
                  </Button>
                )}

                {workflowStep === 2 && (
                  <>
                    <Flex justify={"space-between"} mb={"xs"}>
                      <Button
                        w={"48%"}
                        color="dark"
                        variant="outline"
                        disabled={
                          isDisabled ||
                          loading ||
                          images.length > 0 ||
                          filesArray.length > 0
                        }
                        onClick={handleSendAsDraft}
                        loading={loading}
                      >
                        {`Send draft messages`}
                      </Button>

                      <Button
                        w={"48%"}
                        color="dark"
                        disabled={isDisabled || loading}
                        onClick={handleSendNow}
                        loading={loading}
                      >
                        {`Send (can't be undone)`}
                      </Button>
                    </Flex>
                    <Box>
                      <Text size={14} color={"dimmed"}>
                        Draft enters your message into the chats’ message input
                        in Telegram, so you can personalize and edit before
                        sending.
                      </Text>
                      {images.length > 0 && (
                        <Text size={14} color={"dimmed"} mt={"10px"}>
                          Can't send as draft because message includes an image.
                        </Text>
                      )}
                      {filesArray.length > 0 && (
                        <Text size={14} color={"dimmed"} mt={"10px"}>
                          Can't send as draft because message includes a file.
                        </Text>
                      )}
                    </Box>
                  </>
                )}
              </Container>
              <AlertToast
                setShowErrorAlert={setShowErrorAlert}
                showErrorAlert={showErrorAlert}
                setShowSuccessAlert={setShowSuccessAlert}
                showSuccessAlert={showSuccessAlert}
                setCustomErrorMessage={setCustomErrorMessage}
                customErrorMessage={customErrorMessage}
              />
            </Box>
          </Flex>
        </Container>
      )}
    </>
  );
}
